module.exports = __webpack_public_path__ + "img/startConfigurationAttachmentSetting.1f1829f.webp";